// extracted by mini-css-extract-plugin
export var childrenContainer = "_3x-0";
export var virtualScrollArea = "_3x-1";